/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type VisitOptionSelectionMetadataVisitTypePreference =
  | (typeof VisitOptionSelectionMetadataVisitTypePreference)[keyof typeof VisitOptionSelectionMetadataVisitTypePreference]
  | null;

export const VisitOptionSelectionMetadataVisitTypePreference = {
  chat: "chat",
  audiovisual: "audiovisual",
} as const;
